export const PICK_PROMOTIONAL_BOXES_PAGE = 'PICK_PROMOTIONAL_BOXES_PAGE';
export const UPDATE_PROMOTIONAL_BOX_EXTERNAL_URL =
    'UPDATE_PROMOTIONAL_BOX_EXTERNAL_URL';
export const UPDATE_PROMOTIONAL_BOX_BUTTON_TEXT =
    'UPDATE_PROMOTIONAL_BOX_BUTTON_TEXT';
export const UPDATE_PROMOTIONAL_BOX_HEADING = 'UPDATE_PROMOTIONAL_BOX_HEADING';
export const UPDATE_PROMOTIONAL_BOX_SUBHEADING =
    'UPDATE_PROMOTIONAL_BOX_SUBHEADING';
export const UPDATE_PROMOTIONAL_BOX_TEXT = 'UPDATE_PROMOTIONAL_BOX_TEXT';
export const ADD_IMAGE_IN_PROMOTIONAL_BOX_POPUP =
    'ADD_IMAGE_IN_PROMOTIONAL_BOX_POPUP';
export const UPDATE_THUMB_CROPPED_IMAGE_IN_PROMOTIONAL_BOX_POPUP =
    'UPDATE_THUMB_CROPPED_IMAGE_IN_PROMOTIONAL_BOX_POPUP';
export const REMOVE_IMAGE_IN_PROMOTIONAL_BOX_POPUP =
    'REMOVE_IMAGE_IN_PROMOTIONAL_BOX_POPUP';
export const UPDATE_IMAGE_META_IN_PROMOTIONAL_BOX_POPUP =
    'UPDATE_IMAGE_META_IN_PROMOTIONAL_BOX_POPUP';
export const UPDATE_CROPPED_IMAGE_IN_PROMOTIONAL_BOX_POPUP =
    'UPDATE_CROPPED_IMAGE_IN_PROMOTIONAL_BOX_POPUP';



// WEBPACK FOOTER //
// ./src/containers/builder/sections/types/promotional_boxes_types.js